import React, { useState, useEffect, useRef } from 'react';
import { db } from 'config/firebase';
import { collection, query, getDocs, where, addDoc } from 'firebase/firestore';
import { Row, Col, Button, Modal, InputGroup, FormControl } from 'react-bootstrap';
import AdvanceTableWrapper from 'components/merlin/advance-table/AdvanceTableWrapper';
import AdvanceTable from 'components/merlin/advance-table/AdvanceTable';
import AdvanceTableSearchBox from 'components/merlin/advance-table/AdvanceTableSearchBox';
import AdvanceTableFooter from 'components/merlin/advance-table/AdvanceTableFooter';
import { toast } from 'react-toastify';

const CreateNewBatchModal = ({ show, handleClose, uid }) => {

  const [loading, setLoading] = useState(true);
  const [shipStationBatches, setShipStationBatches] = useState([]);
  useEffect(() => {
    // this loads the most recent batches configured in ShipStation
    setLoading(true);
    async function getBatchShipstationBatches() {
      // extract from processedOrders all of the unique batch numbers
      const oneWeekAgo = new Date();
      oneWeekAgo.setDate(oneWeekAgo.getDate() - 1);
      const querySnapshot = await getDocs(
        query(
          collection(db, 'processedOrders'),
          where('modifyDate', '>', oneWeekAgo)
        )
      );
      const batchNumbers = [];
      querySnapshot.forEach((doc) => {
        const data = doc.data().batchName;
        if (data) {
          batchNumbers.push(data);
        }
      });
      // return only the unique batch numbers
      // reverse the array so the most recent batches are at the top  
      const uniqueBatchNumbers = [...new Set(batchNumbers)];
      uniqueBatchNumbers.reverse();
      const returnObject = [];
      uniqueBatchNumbers.forEach((batch) => {
        returnObject.push({ batchName: batch });
      });
      return returnObject;
      // return [...new Set(batchNumbers)];
    }
    getBatchShipstationBatches().then((batches) => {
      setShipStationBatches(batches);
      setLoading(false);
    }).catch((error) => {
      console.log(error)
    })
  }, []);

  return (
    <>
      <Modal
        show={show}
        onHide={() => handleClose()}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Row>
            <Col>
              <Modal.Title id="contained-modal-title-vcenter">Create New Batch</Modal.Title>
            </Col>
          </Row>
          <Row>
            <Col>
              <div className='fs-1 mb-2'>

              </div>
            </Col>
          </Row>
        </Modal.Header>
        <Modal.Body>
          <div>
            {
              loading ?
                <div>Loading ShipStation Batches...</div> :
                shipStationBatches && shipStationBatches.length > 0 ?
                  <ShipStationBatchNameTable data={shipStationBatches} uid={uid} />
                  :
                  <div>No ShipStation batches found</div>
            }
          </div>

        </Modal.Body>
        <Modal.Footer className=''>
          <Button variant="secondary" onClick={() => handleClose()}>Close</Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default CreateNewBatchModal;

const ShipStationBatchNameTable = ({ data, uid }) => {
  const [selectedBatch, setSelectedBatch] = useState(null);
  const manualBatchNameRef = useRef(null);

  function createFromShipStation(value) {
    setSelectedBatch(value);
  }

  function createManualBatch() {
    const batchName = manualBatchNameRef.current.value;
    setSelectedBatch(batchName);
  }

  async function finalizeBatch() {
    if (!selectedBatch) {
      toast.error('No batch selected');
      return;
    }
    const rightNow = new Date();
    const newBatch = {
      doNotPick: false,
      items: [],
      orderBatchName: selectedBatch,
      status: 'Initialized',
      timestamp: rightNow,
      uid: uid
    }
    const docRef = await addDoc(collection(db, 'batches'), newBatch);
    console.log('Document written with ID: ', docRef.id);
    toast.success('Batch created successfully');
    setSelectedBatch(null);
  }

  const SelectedBatch = ({ selectedBatch }) => {
    return (
      <div>
        <Row className='fs-1 mb-2'>
          <Col className='' lg={8}>
            Selected Batch: {selectedBatch}
          </Col>
          <Col className='float-end' lg={4}>
            <Button variant="secondary" onClick={() => setSelectedBatch(null)}>X</Button>
          </Col>
        </Row>
        <Row>
          <Col>
            <div>
              <Button variant="success" onClick={() => finalizeBatch()}>Create Batch</Button>
            </div>
          </Col>
        </Row>
      </div>
    )
  }

  const ManualBatchCreationForm = () => {
    return (
      <>
        <InputGroup className="mb-3">
          <InputGroup.Text id="basic-addon1">Batch Name</InputGroup.Text>
          <FormControl
            placeholder="Enter name for batch"
            aria-label="Batch Name"
            aria-describedby="basic-addon1"
            ref={manualBatchNameRef}
            onSubmit={() => createManualBatch()}
          />
          <Button variant="success" id="button-addon2" onClick={() => createManualBatch()}>
            Create
          </Button>
        </InputGroup>
      </>
    )
  }

  const columns = [
    {
      accessor: 'batchName',
      Header: 'Name',
      headerProps: { className: 'text-900' },
      Cell: (props) => {
        return (
          <div onClick={() => createFromShipStation(props.value)}>
            {props.value}
          </div>
        )
      }
    },
  ];

  return (
    <>
      {
        selectedBatch ?
          <div>
            <SelectedBatch selectedBatch={selectedBatch} />
          </div>
          :
          <div>
            <AdvanceTableWrapper
              columns={columns}
              data={data}
              sortable
              pagination
              perPage={5}
            >
              <AdvanceTableSearchBox table />
              <AdvanceTable
                table
                headerClassName="bg-200 text-nowrap align-middle"
                rowClassName="align-middle white-space-nowrap"
                tableProps={{
                  bordered: true,
                  striped: true,
                  className: 'fs-10 mb-0 overflow-hidden'
                }}
              />
              <div className="mt-3">
                <AdvanceTableFooter
                  rowCount={data.length}
                  table
                  rowInfo
                  navButtons
                  rowsPerPageSelection
                />
              </div>
            </AdvanceTableWrapper>
            <div className='mt-3'>
              <ManualBatchCreationForm />
            </div>
          </div>
      }

    </>
  )
}
